import { render } from "./UpdatePeriod.vue?vue&type=template&id=5648aaac&scoped=true&ts=true"
import script from "./UpdatePeriod.vue?vue&type=script&lang=ts"
export * from "./UpdatePeriod.vue?vue&type=script&lang=ts"

import "./UpdatePeriod.vue?vue&type=style&index=0&id=5648aaac&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5648aaac"]])

export default __exports__